import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import lessonService from './lessonService';

const initialState = {
  lessons: [],
  lesson: null,
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: '',
};

// Get lessons by course ID
export const getLessonsByCourse = createAsyncThunk(
  'lessons/getByCourse',
  async (courseId, thunkAPI) => {
    try {
      return await lessonService.getLessonsByCourse(courseId);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get lesson by ID
export const getLessonById = createAsyncThunk(
  'lessons/getById',
  async (lessonId, thunkAPI) => {
    try {
      return await lessonService.getLessonById(lessonId);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Mark lesson as completed
export const markLessonCompleted = createAsyncThunk(
  'lessons/markCompleted',
  async (lessonId, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await lessonService.markLessonCompleted(lessonId, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const lessonSlice = createSlice({
  name: 'lessons',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = '';
    },
    clearLesson: (state) => {
      state.lesson = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get lessons by course cases
      .addCase(getLessonsByCourse.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLessonsByCourse.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.lessons = action.payload;
      })
      .addCase(getLessonsByCourse.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Get lesson by ID cases
      .addCase(getLessonById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLessonById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.lesson = action.payload;
      })
      .addCase(getLessonById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Mark lesson as completed cases
      .addCase(markLessonCompleted.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(markLessonCompleted.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // Update the lesson in state if it exists
        if (state.lesson && state.lesson._id === action.payload._id) {
          state.lesson = action.payload;
        }
        // Update the lesson in the lessons array if it exists
        state.lessons = state.lessons.map((lesson) =>
          lesson._id === action.payload._id ? action.payload : lesson
        );
      })
      .addCase(markLessonCompleted.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset, clearLesson } = lessonSlice.actions;
export default lessonSlice.reducer;